export default (itemId) => {
  window.dispatchEvent(
    new CustomEvent('itemMoveStart', {
      detail: { id: itemId },
    })
  );
};
